export default __webpack_public_path__ + "static/media/Eb3.9858b18f.mp3";